import styles from "./ChannelEditorialProject.module.scss";
import { ChannelEditorialProjectFragment } from "types/api";
import Image from "components/Image";
import LandingMetadata from "./LandingMetadata";
import gql from "graphql-tag";

const ChannelEditorialProject = ({
  displayName,
  url,
  river,
}: ChannelEditorialProjectFragment) => {
  const latestPromo = river.edges?.[0]?.node;
  return (
    <section className={styles.root}>
      <span className={styles.rubric}>Projects</span>
      <a
        href={url}
        className={styles.projectLink}
        data-action="click link - project - rubric"
      >
        <h2 className={styles.project}>{displayName}</h2>
      </a>
      {latestPromo && (
        <article className={styles.promoItem}>
          <a
            href={latestPromo.url}
            className={styles.titleLink}
            data-action="click link - project - title"
          >
            {latestPromo.riverImage && (
              <Image
                src={latestPromo.riverImage.url}
                srcSet={latestPromo.riverImage.srcSet || undefined}
                width={latestPromo.riverImage.width}
                height={latestPromo.riverImage.height}
                alt={latestPromo.riverImage.altText || ""}
                lazy={true}
                className={styles.image}
              />
            )}
            <h2
              className={styles.title}
              dangerouslySetInnerHTML={{ __html: latestPromo.title }}
            />
          </a>
          {latestPromo.dek && (
            <p
              className={styles.dek}
              dangerouslySetInnerHTML={{ __html: latestPromo.dek }}
            />
          )}
          <div className={styles.metadata}>
            <LandingMetadata {...latestPromo} analyticsSection="project" />
          </div>
        </article>
      )}
    </section>
  );
};

ChannelEditorialProject.fragment = gql`
  ${LandingMetadata.fragment}

  fragment channelEditorialProject on EditorialProject {
    url
    displayName
    river(first: 1) {
      edges {
        node {
          id
          url
          title
          dek
          ...landingMetadata
          riverImage(width: 180, height: 111, sizes: ["1x", "2x"]) {
            id
            url
            srcSet
            width
            height
            altText
          }
        }
      }
    }
  }
`;

export default ChannelEditorialProject;
